module.exports = __webpack_public_path__ + "img/title_img.1ddfbb4f.png";